import * as Cookies from 'js-cookie';

type ToggleStateMap = {[key: string]: boolean};
type FeatureState = Map<string, boolean>;

export class FeatureStorageServer {
    private state: string;

    public constructor (serverSideValues: string) {
        this.state = serverSideValues;
    }

    public load (): FeatureState {
        const deserializedValue: ToggleStateMap = JSON.parse(this.state);

        // convert from object to a list of "[toggle name, true/false]" arrays => base for initializing a Map() instance
        const mapEntries: Array<[string, boolean]> = Object.keys(deserializedValue).map((key: string) => [key, deserializedValue[key]]);

        return new Map(mapEntries);
    }
}

export class FeatureStorageCookie {
    private readonly _cookieName: string;

    private readonly cookieConfig: Cookies.CookieAttributes = {
        path: '/',
        sameSite: 'strict',
    };

    public constructor (cookieName: string) {
        this._cookieName = cookieName;
    }

    read (): FeatureState {
        const storedValue: string | undefined = Cookies.get(this._cookieName);

        if (storedValue === undefined) {
            return new Map();
        }
        const deserializedValue: ToggleStateMap = JSON.parse(storedValue);

        // convert from object to a list of "[toggle name, true/false]" arrays => base for initializing a Map() instance
        const mapEntries: Array<[string, boolean]> = Object.keys(deserializedValue).map((key: string) => [key, deserializedValue[key]]);

        return new Map(mapEntries);
    }

    write (values: FeatureState): void {
        const entries = Array.from(values.entries())
            .reduce<ToggleStateMap>(
                function (acc: ToggleStateMap, entry: [string, boolean]) {
                    acc[entry[0]] = entry[1];
                    return acc;
                },
                {}
            );

        Cookies.set(this._cookieName, JSON.stringify(entries), this.cookieConfig);
    }
}
